import { controls,grouped } from "../controls";
const account_atms = {
label: "Account Atms",
pageLabel: "Account Atms",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Account Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "account_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Card Number"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "card_number",maxlength:16}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Name On Card"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "name_on_card",maxlength:20}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "filter", label: "Valid Through",target: "valid_through"}),
...controls.magicDate({ tab: "filter", name: "valid_through", dateType: "ontype" }),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Account",star:false}),
...controls.oc({ tab: "general", c: "Account", placeHolder: "Account Code", name: "account_code",fastpath: "accounts",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "account_display"}),
...controls.displayText({ tab: "general", label: "Card Number",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "card_number",maxlength:16}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Confirm Card Number",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "confirm_card_number",maxlength:16}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Name On Card",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "name_on_card",maxlength:20}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "Block Date",target: "block_date",star:false}),
...controls.magicDate({ tab: "general", name: "block_date", dateType: "ontype" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "Valid Through",target: "valid_through",star:false}),
...controls.magicDate({ tab: "general", name: "valid_through", dateType: "ontype" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Daily Limit"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "daily_limit",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Monthly Limit"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "monthly_limit",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Transaction Limit"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "transaction_limit",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
]
,history:{
perPage: 10,
reportHeader: "Account Atms",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Account Id",accessor: "account_id",},
{Header: "Card Number",accessor: "card_number",},
{Header: "Name On Card",accessor: "name_on_card",},
{Header: "Block Date",accessor: "block_date",type:'date'},
{Header: "Valid Through",accessor: "valid_through",type:'date'},
{Header: "Daily Limit",accessor: "daily_limit",},
{Header: "Monthly Limit",accessor: "monthly_limit",},
{Header: "Transaction Limit",accessor: "transaction_limit",},
{Header: "Account Atm Active",accessor: "account_atm_active",type:'tick'},
]}};
export default account_atms;